var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":_vm.cols}},[_c('v-switch',{attrs:{"label":_vm.label,"color":"primary","hide-details":"","input-value":_vm.valueField},on:{"change":function($event){return _vm.$emit('update:value', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }